import classNames from 'classnames';
import { useState, useEffect, useRef, forwardRef } from 'react';
const wistiaResponsivePaddingCss = "wlm56w7";
const WistiaResponsivePadding = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wistiaResponsivePaddingCss, props.className)} />;
});
const wistiaResponsiveWrapperCss = "w15m35ak";
const WistiaResponsiveWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wistiaResponsiveWrapperCss, props.className)} />;
});
const wistiaEmbedAsyncCss = "wv1t40l";
const WistiaEmbedAsync = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wistiaEmbedAsyncCss, props.className)} />;
});
const wistiaSwatchCss = "w18itot9";
const WistiaSwatch = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wistiaSwatchCss, props.className)} />;
});
const wistiaImgCss = "wx77lf2";
const WistiaImg = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(wistiaImgCss, props.className)} />;
});
const buildEmbedClassName = (videoId, loop) => {
  const embedOptions = ['seo=false', 'videoFoam=true'];
  if (loop === false) {
    embedOptions.push('endVideoBehavior=default');
  } else if (loop === true) {
    embedOptions.push('endVideoBehavior=loop');
  }
  return `wistia_embed wistia_async_${videoId} ${embedOptions.join(' ')}`;
};

// https://dev.to/tanveermughal/intergrating-wistia-video-player-into-your-react-appcomplete-code-4lfe
export const WistiaPlayer = ({
  videoId,
  onPlay,
  autoplay = false,
  loop
}) => {
  const imgRef = useRef(null);
  const containerRef = useRef(null);
  const [addedScripts, setAddedScripts] = useState(false);
  useEffect(() => {
    setAddedScripts(false);
  }, [videoId]);
  useEffect(() => {
    if (!addedScripts) {
      const script1 = document.createElement('script');
      script1.src = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`;
      script1.async = true;
      const script2 = document.createElement('script');
      script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      script2.async = true;
      const container = containerRef.current;
      container.prepend(script2);
      container.prepend(script1);
      setAddedScripts(true);
    }
    window._wq_vIds = window._wq_vIds || {};
    if ((onPlay || autoplay) && !window._wq_vIds[videoId]) {
      window._wq = window._wq || [];
      window._wq.push({
        id: videoId,
        onReady: video => {
          if (onPlay) {
            video.bind('play', () => {
              onPlay();
              return video.unbind;
            });
          }
          if (autoplay) {
            video.play();
          }
        }
      });
      window._wq_vIds[videoId] = true;
    }
    // Explicit cleanup to reset autoplay state if component needs to remount
    return () => {
      if (window._wq_vIds && window._wq_vIds[videoId]) {
        delete window._wq_vIds[videoId];
      }
    };
  }, [videoId, onPlay, addedScripts, autoplay]);
  return <div ref={containerRef} id={`wistia-player-${videoId}`}>
      <WistiaResponsivePadding className="wistia_responsive_padding">
        <WistiaResponsiveWrapper className="wistia_responsive_wrapper">
          <WistiaEmbedAsync className={buildEmbedClassName(videoId, loop)}>
            <WistiaSwatch className="wistia_swatch">
              <WistiaImg ref={imgRef} alt={`${videoId} video`} src={`https://fast.wistia.com/embed/medias/${videoId}/swatch`} onLoad={() => {
              imgRef.current.parentNode.style.opacity = '1';
            }} />
            </WistiaSwatch>
          </WistiaEmbedAsync>
        </WistiaResponsiveWrapper>
      </WistiaResponsivePadding>
    </div>;
};

require("./wistia-player.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./wistia-player.js");